import React from 'react';
import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Redirect, Route } from 'react-router';

//	C S S   D E F A U L T S

import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

//	T H E M E

import './theme/theme.fonts.scss';
import './theme/theme.variables.scss';
import './theme/theme.global.scss';
import './theme/theme.modals.scss';

//	P A G E S

import SbDigitalmenuViewPage from './pages/sb-digitalmenu-view/sb-digitalmenu-view';
import SbInfoAllergensPage from './pages/sb-info/sb-info-allergens/sb-info-allergens';

//	S E T U P

setupIonicReact({ mode: 'ios' });

//	C L A S S

export default class App extends React.Component<{}, {}> {

//#region 																							R E N D E R

	render() : React.ReactNode {
		return (
			<IonApp>
				<IonReactRouter>
					<IonRouterOutlet>
						<Route path="/:id" component={(___p: any) => (<SbDigitalmenuViewPage {...___p} />)} exact />
						<Route path="/info/allergens" component={(___p: any) => (<SbInfoAllergensPage {...___p} />)} exact />
						<Redirect to="/:id" />
					</IonRouterOutlet>
				</IonReactRouter>
			</IonApp>
		);
	}

//#endregion

}